import { api } from '@/constants'
import { getAuthHeader, serializeQueryParams } from '@/util'
import baseURL from '@/service/api'

const smesco = {
  feeSettings: params => {
    const url = api.smesco.feeSettings + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  feeSettingDetail: id => {
    const url = api.smesco.feeSettingDetail(id)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  createFeeSetting: payloads => {
    const url = api.smesco.feeSettings
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  updateFeeSetting: (id, payloads) => {
    const url = api.smesco.feeSettingDetail(id)
    return baseURL.put(url, payloads, { headers: getAuthHeader() })
  },
  deleteFeeSetting: id => {
    const url = api.smesco.feeSettingDetail(id)
    return baseURL.delete(url, { headers: getAuthHeader() })
  },
  revenues: params => {
    const url = api.smesco.revenues + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  createRevenue: payloads => {
    const url = api.smesco.revenues
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  approveRevenue: id => {
    const url = api.smesco.revenueApprove(id)
    return baseURL.put(url, {}, { headers: getAuthHeader() })
  },
  deleteRevenue: id => {
    const url = api.smesco.revenueDetail(id)
    return baseURL.delete(url, { headers: getAuthHeader() })
  }
}

export default smesco
